import { Component } from '@angular/core';
import { LoginService } from '../../services/frontdoor/login.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrl: './forgot.component.scss'
})
export class ForgotComponent {
  email = '';

  constructor(private loginService: LoginService, private router: Router) {}

  onSendCode() {
    if (!this.email) {
      alert('Please enter your email.');
      return;
    }
    this.loginService.forgot(this.email).subscribe(res => {
      if (res.success) {
        alert(res.message);
        // Possibly navigate to reset page
        this.router.navigate(['/reset']);
      } else {
        alert(res.message);
      }
    }, err => {
      console.error(err);
      alert('Server error');
    });
  }
}

